(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/inherits", "@babel/runtime/helpers/possibleConstructorReturn", "@babel/runtime/helpers/getPrototypeOf", "@babel/runtime/helpers/classCallCheck", "@babel/runtime/helpers/createClass", "./IterableConfig", "../constants"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/inherits"), require("@babel/runtime/helpers/possibleConstructorReturn"), require("@babel/runtime/helpers/getPrototypeOf"), require("@babel/runtime/helpers/classCallCheck"), require("@babel/runtime/helpers/createClass"), require("./IterableConfig"), require("../constants"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.classCallCheck, global.createClass, global.IterableConfig, global.constants);
    global.IterableActionRunner = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _classCallCheck2, _createClass2, _IterableConfig, _constants) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.IterableActionRunner = void 0;
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
  var IterableActionRunnerImpl = /*#__PURE__*/function () {
    function IterableActionRunnerImpl() {
      (0, _classCallCheck2["default"])(this, IterableActionRunnerImpl);
    }
    (0, _createClass2["default"])(IterableActionRunnerImpl, null, [{
      key: "executeAction",
      value: function executeAction(context, action, source) {
        if (action === null) {
          return false;
        }
        var actionContext = {
          action: action,
          source: source
        };
        if (action.type === _constants.URL_SCHEME_OPEN) {
          return IterableActionRunnerImpl.openUri(action.data, actionContext);
        }
        return IterableActionRunnerImpl.callCustomActionIfSpecified(action, actionContext);
      }
    }, {
      key: "openUri",
      value: function openUri(uri, actionContext) {
        if (_IterableConfig.IterableConfig.urlHandler) {
          if (_IterableConfig.IterableConfig.urlHandler.handleIterableURL(uri, actionContext)) {
            return true;
          }
        }
        window.open(uri, '_blank');
        return true;
      }
    }, {
      key: "callCustomActionIfSpecified",
      value: function callCustomActionIfSpecified(action, actionContext) {
        if (action.type && action.type !== '') {
          if (_IterableConfig.IterableConfig.customActionHandler) {
            return _IterableConfig.IterableConfig.customActionHandler.handleIterableCustomAction(action, actionContext);
          }
        }
        return false;
      }
    }]);
    return IterableActionRunnerImpl;
  }();
  var IterableActionRunner = _exports.IterableActionRunner = /*#__PURE__*/function (_IterableActionRunner) {
    (0, _inherits2["default"])(IterableActionRunner, _IterableActionRunner);
    var _super = _createSuper(IterableActionRunner);
    function IterableActionRunner() {
      (0, _classCallCheck2["default"])(this, IterableActionRunner);
      return _super.apply(this, arguments);
    }
    return (0, _createClass2["default"])(IterableActionRunner);
  }(IterableActionRunnerImpl);
});